module.exports = __webpack_public_path__ + "static/media/green-energy.0a72dbc4.png";